import { type RefObject, useEffect, useRef } from "react";

export const useClickOutside = (
  handler: (event: MouseEvent) => void,
  ...refs: Array<RefObject<HTMLElement | null>>
) => {
  const handlerRef = useRef(handler);
  const refsRef = useRef(refs);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    refsRef.current = refs;
  });

  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const activeRefs = refsRef.current;
      if (
        activeRefs.length > 0 &&
        activeRefs.every(
          (ref) => ref.current && !ref.current.contains(event.target as Node),
        )
      ) {
        handlerRef.current?.(event);
      }
    };

    document.addEventListener("mousedown", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, []);
};
